import { all } from 'redux-saga/effects';

import chat from './chats/sagas';

export default function* rootSaga() {
  const sagas: unknown = yield all([chat]);
  return sagas;
}
